export default __webpack_public_path__ + "static/blob-30dc74794d0851d82ba3517e06a68b51.png";